import React from 'react'
import TEXT from '../Text';
import { NumberInputSettings } from '../FormFields';
import { identity } from "../../../utils/getIdentity";
import { useTranslation } from "react-i18next";

const SystemRefund = ({name}) => {
  const { t } = useTranslation();
  return (
    <div className={`system-fee-setting system-fee-setting-${identity}`}>
    <TEXT.sectionTitle>{t('admin.refund_limit')}</TEXT.sectionTitle>
    <TEXT.sectionDescription className={`system-fee-switcher__description system-fee-switcher__description-${identity}`}>
      {t('admin.choose_refund_limit')}
    </TEXT.sectionDescription>
    <NumberInputSettings name={name} className="system-fee-setting__input" />
  </div>
  )
}

export default SystemRefund